import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import "./index.scss";

@inject('store')
@observer
class index extends Component {

    componentDidMount() {
        this.props.store.criticism.getData(this.props.store.groupChannels.rival);
    }

    render() {
        const { data, loading } = this.props.store.criticism;
        const listName = {
            '早餐': "Breakfast",
            '周边环境': "Environment",
            '位置': "Location",
            '交通': "Transportation",
            '卫生': "Clean",
            '房间环境': "Rooms",
            '服务': "Service",
        };
        return (
            <div className="groupOfChannels_rank">
                <div className="rank_title">批评最多 TOP 7 Negative Comments</div>
                {data.map((item, index) => {
                    return <div className="list" key={index}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            this.props.history.push(`/table/criticism/${item.name}/${this.props.store.groupChannels.rival}`)
                        }}
                    >
                        <div>
                            <span className={index == 0 ? "rankNum rankNum1" : index == 1 ? "rankNum rankNum2" : index == 2 ? "rankNum rankNum3" : "rankNum"}>
                                {index + 1}
                            </span>
                            <span>{item.name} {listName[item.name]} </span>
                        </div>
                        <div>
                            <span className="rising">{item.num}</span>
                            {/* <span><img
                                style={{ marginTop: -6 }}
                                src={item.is_rising ? imgTop : imgDown} /></span> */}
                        </div>
                    </div>
                })}
            </div>

        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/guestRating/channels/rank.js